module.exports = __webpack_public_path__ + "media/svg/logo-maxia-073f8efd.svg";